module.exports = __webpack_public_path__ + "static/media/ye.cfa7605e.webp";